module.exports = __webpack_public_path__ + "static/media/Stage.abcca924.webp";